const CANCELLED_STATUSES = new Set([
  'annulliert',
  'abgesagt',
  'verlegt',
  'Wertung',
  'nicht ausgetragen',
  'Walkover'
])

export function isMatchCancelled (status) {
  return status && CANCELLED_STATUSES.has(status.trim())
}

export function compareMatchesByLiveAndDate (a, b, isNumeric) {
  const livea = isNumeric(a.livegoalshome) && isNumeric(a.livegoalsguest) &&
    !isNumeric(a.goalshome) && !isNumeric(a.goalsguest)
  const liveb = isNumeric(b.livegoalshome) && isNumeric(b.livegoalsguest) &&
    !isNumeric(b.goalshome) && !isNumeric(b.goalsguest)
  const live = livea === liveb ? 0 : (livea ? -1 : 1)
  if (isMatchCancelled(a.status)) return 1
  if (isMatchCancelled(b.status)) return -1
  return live || Date.parse(a.matchdate) - Date.parse(b.matchdate) || a.id - b.id
}

export function sortMatches (matches, isNumeric) {
  return [...matches].sort((a, b) => compareMatchesByLiveAndDate(a, b, isNumeric))
}
